"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Typography_1 = require("../Typography");
var classnames_1 = require("classnames");
var ToggleLabel = function (_a) {
    var variant = _a.variant, label = _a.label, helperText = _a.helperText, isDisabled = _a.isDisabled;
    var disabled = isDisabled !== undefined
        ? isDisabled instanceof Function
            ? isDisabled()
            : isDisabled
        : false;
    var textClasses = [
        'squid-font-alias-font-body-sm-base-font-family',
        'squid-font-alias-font-body-sm-base-font-weight',
        'squid-leading-alias-font-body-sm-base-line-height',
        'squid-text-core-font-size-sm',
    ];
    if (!label) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(variant === 'left' ? 'squid-pr-2' : 'squid-pl-2') }, { children: [label && ((0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "h3", size: "base", strong: false, color: disabled ? 'disabled' : 'weak', className: (0, classnames_1.default)(textClasses) }, { children: label }))), helperText && ((0, jsx_runtime_1.jsx)(Typography_1.Body, __assign({ as: "h2", size: "sm", variant: "base", color: disabled ? 'disabled' : 'weakest', className: (0, classnames_1.default)(textClasses, 'squid-tracking-core-letter-spacing-wide') }, { children: helperText })))] })));
};
exports.ToggleLabel = ToggleLabel;
